import React from 'react';
interface RadioOption {
  value: string;
  label: string;
}
interface RadioGroupProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: RadioOption[];
  required?: boolean;
  layout?: 'vertical' | 'horizontal';
}
export function RadioGroup({
  label,
  value,
  onChange,
  options,
  required = false,
  layout = 'vertical'
}: RadioGroupProps) {
  return <div className="flex flex-col gap-2" data-id="element-120">
      <label className="text-sm font-medium text-gray-700" data-id="element-121">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-122">*</span>}
      </label>
      <div className={`flex gap-4 ${layout === 'vertical' ? 'flex-col' : 'flex-wrap'}`} data-id="element-123">
        {options.map(option => <label key={option.value} className="flex items-center gap-2 cursor-pointer" data-id="element-124">
            <input type="radio" value={option.value} checked={value === option.value} onChange={e => onChange(e.target.value)} required={required} className="w-4 h-4 text-blue-600 focus:ring-2 focus:ring-blue-600" data-id="element-125" />
            <span className="text-sm text-gray-700" data-id="element-126">{option.label}</span>
          </label>)}
      </div>
    </div>;
}